module.exports = __webpack_public_path__ + "src/assets/animations/wasp.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/wasp.txt
// module id = ./src/assets/animations/wasp.txt
// module chunks = 0